import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-my-delete-confirm',
    templateUrl: './my-delete-confirm.component.html',
    styleUrls: ['./my-delete-confirm.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MyDeleteConfirmComponent implements OnInit {
    isDeleting: boolean;
    message: string;
    sendmail: boolean = true;

    @Input()
    onConfirm: any;

    @Input()
    data: any;

    @Input()
    explainMessage: boolean;

    @Input()
    button_disp: string = "Delete"

    constructor() {}

    ngOnInit() {
        this.sendmail = true;
    }

    startDelete() {
        this.isDeleting = true;
    }
    cancel() {
        this.isDeleting = false;
        this.message = '';
    }
    confirm() {
        if (this.explainMessage) {
            this.onConfirm(this.message, this.sendmail);
        } else {
            this.onConfirm(this.data);
        }
    }
}
